<div class="row" [formGroup]="controlGroup">
  <input type="number" formControlName="gt" placeholder="от {{min}}" [min]="min" [max]="max" />
  <p>-</p>
  <input type="number" formControlName="lt" placeholder="до {{max}}" [min]="min" [max]="max" />
</div>
